import script from "./CostBreakdownTab.vue?vue&type=script&setup=true&lang=js"
export * from "./CostBreakdownTab.vue?vue&type=script&setup=true&lang=js"

import "./CostBreakdownTab.vue?vue&type=style&index=0&id=182be97e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-182be97e"]])

export default __exports__